export default __webpack_public_path__ + "ee11c77494158aa0fc4b1cec36560fc0.jpg";